const POPUP_ERRORS = {
	RG_DUPLICATE_PLAYER: 'RG_DUPLICATE_PLAYER',
	PLAYER_EXCEPTION_CLOSED_ACCOUNT: 'PLAYER_EXCEPTION_CLOSED_ACCOUNT'
};
export default POPUP_ERRORS;
